/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Switch } from '../../components/ui/switch';
import {
  DollarSign, Edit2, Trash2, Save, Plus, RefreshCw, Download, Upload,
  ShoppingCart, MapPin, Building2, Briefcase, Tag, BarChart3, Settings,
  TrendingUp, TrendingDown, CheckCircle, XCircle, AlertTriangle, Eye,
  Globe, Filter, Search, Calculator, Percent, Euro, Target, Layers,
  FileSpreadsheet, FileJson, Copy, Archive, Clock, Users, Activity,
  Recycle, Loader2, Coins
} from 'lucide-react';
import axios from 'axios';
import TypesMaitresManager from '../../components/TypesMaitresManager';
import ReferentielsManager from '../../components/ReferentielsManager';
import { toast } from 'sonner';
import {
  TARIF_TYPES, TERRITOIRES, TYPES_ENTREPRISES, ACTIVITES_PROFESSIONNELLES,
} from '../GestionTarifsDemandesPubliques.constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const DemandesTab = ({ ctx }) => {
  const {
    activeTab, tarifs, tarifsParTerritoire, tarifsParType, tarifsParEntreprise,
    configParTypeBySpace, activeSpaceTarif, dirtyTypeBySpace, configParEntreprise,
    configParTerritoire, demandes, stats, loading, searchTerm, selectedTerritoire,
    selectedType, selectedStatut, tarifDialogOpen, editingTarif, statsDialogOpen,
    tarifForm, territoiresList, typesEntrepriseList, typesDemandeList, remisesPolitique,
    remisesPolitiqueLoading, viewDialogOpen, viewingDemande, demandeDialogOpen,
    editingDemande, demandeForm, programmees, programmeesLoading, tickNow,
    setActiveTab, setTarifs, setTarifsParTerritoire, setTarifsParType, setTarifsParEntreprise,
    setConfigParTypeBySpace, setActiveSpaceTarif, setDirtyTypeBySpace, setConfigParEntreprise,
    setConfigParTerritoire, setDemandes, setStats, setLoading, setSearchTerm, setSelectedTerritoire,
    setSelectedType, setSelectedStatut, setTarifDialogOpen, setEditingTarif, setStatsDialogOpen,
    setTarifForm, setTerritoiresList, setTypesEntrepriseList, setTypesDemandeList, setRemisesPolitique,
    setRemisesPolitiqueLoading, setViewDialogOpen, setViewingDemande, setDemandeDialogOpen,
    setEditingDemande, setDemandeForm, setProgrammees, setProgrammeesLoading, setTickNow,
    fetchAllData, fetchConfigTerritoires, fetchConfigTypesAllSpaces, fetchDemandes, fetchProgrammees,
    fetchStats, fetchTarifs, filteredDemandes, formatCountdown, getTerritoireInfo, getTypeInfo,
    handleAdminDeleteDemande, handleAdminDuplicateDemande, handleAdminEditDemande, handleCancelSchedule,
    handleCloneFromDefault, handleDeleteTarif, handleDuplicateTarif, handleExport, handlePublishNow,
    handleSaveAdminDemande, handleSaveAllConfigTypeSpace, handleSaveConfigEntreprise,
    handleSaveConfigTerritoire, handleSaveConfigType, handleSaveTarif, handleToggleTarif, handleViewDemande,
    loadReferentielsFromApi, loadRemisesPolitique, openEditDialog, parseActivitesFromDemande,
    resetTarifForm, saveRemisesPolitique, toggleActivite, updateConfigEntreprise, updateConfigTerritoire,
    updateConfigType, SPACES_TARIF, getAuthHeader, emptyTypeConfig,
  } = ctx;
  return (
        <TabsContent value="demandes" className="mt-4 space-y-4">
          {/* V36.41 — Header avec bouton "Nouvelle demande" (admin) */}
          <div className="flex items-center justify-between bg-white rounded-xl border-l-4 border-emerald-500 p-4 shadow-sm">
            <div>
              <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                <ShoppingCart className="h-5 w-5 text-emerald-600" />
                Demandes publiques
              </h3>
              <p className="text-xs text-slate-500">CRUD complet pour le Super Admin : ajout, modification, duplication, suppression.</p>
            </div>
            <Button
              onClick={() => { setEditingDemande(null); setDemandeForm({ title: '', description: '', secteur: 'general', territoire: 'metropole', type_entreprise: 'all', type_demande: 'standard', ville: '', notes: '', raison_sociale: '', siret: '', nom: '', prenom: '', email: '', telephone: '', adresse: '', code_postal: '', activites: [], publication_mode: 'immediat', publication_scheduled_at: '' }); setDemandeDialogOpen(true); }}
              className="bg-emerald-600 hover:bg-emerald-700"
              data-testid="add-demande-btn"
            >
              <Plus className="h-4 w-4 mr-1.5" /> Nouvelle demande
            </Button>
          </div>

          {/* V37.30 — Panel « Programmées & Brouillons » */}
          {programmees.length > 0 && (
            <Card className="border-0 shadow-lg bg-gradient-to-br from-indigo-50 via-white to-purple-50" data-testid="programmees-panel">
              <CardContent className="p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <Clock className="h-5 w-5 text-indigo-600" />
                    <h4 className="text-sm font-bold text-slate-800 uppercase tracking-wide">
                      Demandes programmées &amp; brouillons
                    </h4>
                    <Badge className="bg-indigo-600 text-white font-semibold" data-testid="programmees-count">
                      {programmees.length}
                    </Badge>
                  </div>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={fetchProgrammees}
                    disabled={programmeesLoading}
                    className="text-xs"
                    data-testid="programmees-refresh"
                  >
                    <RefreshCw className={`h-3.5 w-3.5 mr-1 ${programmeesLoading ? 'animate-spin' : ''}`} />
                    Actualiser
                  </Button>
                </div>
                <div className="space-y-2">
                  {programmees.map((d) => {
                    const isScheduled = d.statut === 'programmee';
                    const isDraft = d.statut === 'brouillon';
                    const countdown = isScheduled ? formatCountdown(d.publication_scheduled_at) : null;
                    return (
                      <div
                        key={d.id}
                        className={`flex items-center justify-between gap-3 p-3 rounded-lg border ${
                          isScheduled
                            ? 'border-amber-300 bg-amber-50/60'
                            : 'border-slate-300 bg-slate-50/60'
                        }`}
                        data-testid={`programmee-item-${d.id}`}
                      >
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="font-semibold text-sm text-slate-800 truncate">
                              {d.title || d.titre || '(sans titre)'}
                            </span>
                            {isScheduled ? (
                              <Badge className="bg-amber-600 text-white text-[10px] uppercase tracking-wide font-semibold" data-testid={`badge-status-${d.id}`}>
                                <Clock className="h-3 w-3 mr-1" />Programmée
                              </Badge>
                            ) : (
                              <Badge className="bg-slate-700 text-white text-[10px] uppercase tracking-wide font-semibold" data-testid={`badge-status-${d.id}`}>
                                <Archive className="h-3 w-3 mr-1" />Brouillon
                              </Badge>
                            )}
                            {d.territoire && (
                              <Badge variant="outline" className="text-[10px]">
                                <MapPin className="h-3 w-3 mr-1" />{d.territoire}
                              </Badge>
                            )}
                          </div>
                          {isScheduled && d.publication_scheduled_at && (
                            <div className="mt-1 text-xs text-amber-800 flex items-center gap-1.5" data-testid={`countdown-${d.id}`}>
                              <Clock className="h-3 w-3" />
                              <span className="font-mono font-semibold">{countdown}</span>
                              <span className="text-slate-500">
                                · publication le {new Date(d.publication_scheduled_at).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}
                              </span>
                            </div>
                          )}
                          {isDraft && (
                            <div className="mt-1 text-xs text-slate-500">
                              Créé le {new Date(d.created_at).toLocaleDateString('fr-FR')} · {d.email || 'pas de contact'}
                            </div>
                          )}
                        </div>
                        <div className="flex items-center gap-1 shrink-0">
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => handleAdminEditDemande(d)}
                            data-testid={`programmee-edit-${d.id}`}
                            title="Modifier"
                            className="h-8 px-2"
                          >
                            <Edit2 className="h-3.5 w-3.5" />
                          </Button>
                          <Button
                            size="sm"
                            onClick={() => handlePublishNow(d)}
                            data-testid={`programmee-publish-now-${d.id}`}
                            title="Publier maintenant"
                            className="h-8 px-2 bg-emerald-600 hover:bg-emerald-700 text-white"
                          >
                            <CheckCircle className="h-3.5 w-3.5" />
                            <span className="hidden md:inline ml-1 text-xs">Publier</span>
                          </Button>
                          {isScheduled && (
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => handleCancelSchedule(d)}
                              data-testid={`programmee-cancel-${d.id}`}
                              title="Annuler la programmation (repasse en brouillon)"
                              className="h-8 px-2 text-amber-700 border-amber-300 hover:bg-amber-100"
                            >
                              <XCircle className="h-3.5 w-3.5" />
                            </Button>
                          )}
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => handleAdminDeleteDemande(d)}
                            data-testid={`programmee-delete-${d.id}`}
                            title="Supprimer définitivement"
                            className="h-8 px-2 text-red-600 hover:bg-red-50"
                          >
                            <Trash2 className="h-3.5 w-3.5" />
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </CardContent>
            </Card>
          )}

          {/* Filtres */}
          <Card className="border-0 shadow-lg">
            <CardContent className="p-4">
              <div className="flex flex-wrap items-center gap-4">
                <div className="relative flex-1 min-w-[200px]">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                  <Input
                    placeholder="Rechercher une demande..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10"
                  />
                </div>
                
                <Select value={selectedTerritoire} onValueChange={setSelectedTerritoire}>
                  <SelectTrigger className="w-[150px]">
                    <SelectValue placeholder="Territoire" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tous territoires</SelectItem>
                    {TERRITOIRES.map(t => (
                      <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                
                <Select value={selectedType} onValueChange={setSelectedType}>
                  <SelectTrigger className="w-[150px]">
                    <SelectValue placeholder="Type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tous types</SelectItem>
                    {TARIF_TYPES.map(t => (
                      <SelectItem key={t.value} value={t.value}>{t.icon} {t.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                
                <Select value={selectedStatut} onValueChange={setSelectedStatut}>
                  <SelectTrigger className="w-[150px]">
                    <SelectValue placeholder="Statut" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tous statuts</SelectItem>
                    <SelectItem value="publiee">Publiée</SelectItem>
                    <SelectItem value="nouvelle">Nouvelle</SelectItem>
                    <SelectItem value="en_cours">En cours</SelectItem>
                    <SelectItem value="achetee">Achetée</SelectItem>
                    <SelectItem value="suspendue">Suspendue</SelectItem>
                  </SelectContent>
                </Select>
                
                <Badge className="bg-slate-700 text-white py-2 font-semibold">
                  {filteredDemandes.length} résultat(s)
                </Badge>
              </div>
            </CardContent>
          </Card>

          {/* Liste des demandes */}
          <Card className="border-0 shadow-lg">
            <CardContent className="p-4">
              {filteredDemandes.length === 0 ? (
                <div className="text-center py-12">
                  <ShoppingCart className="h-16 w-16 mx-auto text-slate-300 mb-4" />
                  <h3 className="text-xl font-semibold text-slate-700">Aucune demande trouvée</h3>
                  <p className="text-slate-500">Modifiez vos filtres pour voir plus de résultats</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {filteredDemandes.slice(0, 20).map(demande => (
                    <div key={demande.id} className="p-4 rounded-lg border bg-white hover:shadow-md transition-all">
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <span className="font-semibold text-slate-800">{demande.titre || demande.entreprise || 'Demande sans titre'}</span>
                            <Badge className="bg-blue-700 text-white font-semibold">{demande.type_demande || 'standard'}</Badge>
                            <Badge className={demande.statut === 'disponible' ? 'bg-green-700 text-white' : 'bg-slate-700 text-white'}>
                              {demande.statut || 'disponible'}
                            </Badge>
                            {demande.oscop_id && (
                              <Badge
                                variant="outline"
                                className="border-amber-400 text-amber-700 font-mono text-[10px] tracking-wider"
                                data-testid={`admin-oscop-id-${demande.id}`}
                              >
                                {demande.oscop_id}
                              </Badge>
                            )}
                          </div>
                          <div className="flex items-center gap-4 text-sm text-slate-500">
                            <span className="flex items-center gap-1"><MapPin className="h-3 w-3" /> {demande.territoire || 'Non spécifié'}</span>
                            <span className="flex items-center gap-1"><Building2 className="h-3 w-3" /> {demande.type_entreprise || 'Non spécifié'}</span>
                            <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {new Date(demande.created_at).toLocaleDateString('fr-FR')}</span>
                          </div>
                        </div>
                        <div className="flex items-center gap-4">
                          <div className="text-right">
                            <div className="font-bold text-emerald-600">{demande.prix || 15}€</div>
                            <div className="text-xs text-slate-500">ou {demande.prix_credits || 5} crédits</div>
                          </div>
                          <div className="flex items-center gap-1">
                            <Button
                              variant="outline" size="sm"
                              onClick={() => handleViewDemande(demande)}
                              title="Voir le detail complet"
                              data-testid={`demande-view-${demande.id}`}
                              className="hover:bg-emerald-50 hover:border-emerald-400"
                            >
                              <Eye className="h-4 w-4" />
                            </Button>
                            <Button
                              variant="ghost" size="sm" className="text-blue-600"
                              onClick={() => handleAdminEditDemande(demande)}
                              title="Modifier"
                              data-testid={`demande-edit-${demande.id}`}
                            >
                              <Edit2 className="h-4 w-4" />
                            </Button>
                            <Button
                              variant="ghost" size="sm" className="text-purple-600"
                              onClick={() => handleAdminDuplicateDemande(demande)}
                              title="Dupliquer"
                              data-testid={`demande-duplicate-${demande.id}`}
                            >
                              <Copy className="h-4 w-4" />
                            </Button>
                            <Button
                              variant="ghost" size="sm" className="text-red-600"
                              onClick={() => handleAdminDeleteDemande(demande)}
                              title="Supprimer"
                              data-testid={`demande-delete-${demande.id}`}
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>
  );
};

export default DemandesTab;
